exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#__AmCharts_React_1__{overflow:visible!important}.slide-img{width:40%;height:40%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/assets/js/app/SchoolProfileView/components/GeographyAndMeteorology/GeographyAndMeteorology.css
// module id = wTst
// module chunks = 3